import React, { useState } from 'react';
import { api } from '../services/api';

const REWARD_CATALOG = [
  {
    id: 'wawa-10',
    name: '$10 Wawa Gift Card',
    description: 'Good for coffee, hoagies, and more!',
    points: 100,
    icon: '☕',
    category: 'gift_card',
    stock: 'unlimited'
  },
  {
    id: 'wawa-25',
    name: '$25 Wawa Gift Card',
    description: 'Bigger treats at Wawa',
    points: 250,
    icon: '🥤',
    category: 'gift_card',
    stock: 'unlimited'
  },
  {
    id: 'amazon-25',
    name: '$25 Amazon Gift Card',
    description: 'Shop for anything on Amazon',
    points: 250,
    icon: '📦',
    category: 'gift_card',
    stock: 'unlimited'
  },
  {
    id: 'lunch-team',
    name: 'Free Team Lunch',
    description: 'Lunch for the whole team (up to $100)',
    points: 500,
    icon: '🍕',
    category: 'experience',
    stock: 'limited',
    remaining: 5
  },
  {
    id: 'phillies-tickets',
    name: 'Phillies Game Tickets (2)',
    description: 'Two tickets to a Phillies home game',
    points: 1000,
    icon: '⚾',
    category: 'experience',
    stock: 'limited',
    remaining: 3
  },
  {
    id: 'eagles-tickets',
    name: 'Eagles Game Tickets (2)',
    description: 'Two tickets to an Eagles home game',
    points: 2500,
    icon: '🏈',
    category: 'experience',
    stock: 'limited',
    remaining: 1
  },
  {
    id: 'concert-100',
    name: 'Concert Tickets ($100 value)',
    description: 'Pick your show at any venue',
    points: 1000,
    icon: '🎸',
    category: 'experience',
    stock: 'unlimited'
  },
  {
    id: 'pto-day',
    name: 'Extra PTO Day',
    description: 'One additional paid day off',
    points: 2000,
    icon: '🏖️',
    category: 'time_off',
    stock: 'limited',
    remaining: 10
  },
  {
    id: 'half-day',
    name: 'Half Day Friday',
    description: 'Leave at noon on a Friday',
    points: 500,
    icon: '🌴',
    category: 'time_off',
    stock: 'unlimited'
  }
];

const RewardsManager = () => {
  const [activeTab, setActiveTab] = useState('catalog');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [showSendRewardModal, setShowSendRewardModal] = useState(false);
  const [selectedReward, setSelectedReward] = useState(null);

  const teamMembers = [
    { id: 'TM-001', name: 'Mike Rodriguez', points: 450 },
    { id: 'TM-002', name: 'Sarah Chen', points: 680 },
    { id: 'TM-003', name: 'James Wilson', points: 320 },
    { id: 'TM-004', name: 'Emily Davis', points: 890 },
  ];

  const recentRedemptions = [
    { id: 1, member: 'Sarah Chen', reward: '$10 Wawa Gift Card', points: 100, date: '2024-01-05', status: 'fulfilled' },
    { id: 2, member: 'Mike Rodriguez', reward: 'Half Day Friday', points: 500, date: '2024-01-03', status: 'approved' },
    { id: 3, member: 'James Wilson', reward: '$25 Amazon Gift Card', points: 250, date: '2023-12-28', status: 'fulfilled' },
  ];

  const pointsHistory = [
    { id: 1, member: 'Mike Rodriguez', type: 'earned', points: 50, reason: 'Completed project ahead of schedule', date: '2024-01-06' },
    { id: 2, member: 'Sarah Chen', type: 'redeemed', points: -100, reason: '$10 Wawa Gift Card', date: '2024-01-05' },
    { id: 3, member: 'All Team', type: 'bonus', points: 25, reason: 'Monthly team bonus', date: '2024-01-01' },
  ];

  const filteredRewards = selectedCategory === 'all' 
    ? REWARD_CATALOG 
    : REWARD_CATALOG.filter(r => r.category === selectedCategory);

  return (
    <div className="rewards-manager">
      {/* Header */}
      <div className="section-header">
        <h2>🎁 Rewards Program</h2>
        <div className="header-actions">
          <button className="btn secondary" disabled title="Coming soon">
            + Add Reward
          </button>
          <button className="btn primary" onClick={() => setShowSendRewardModal(true)}>
            🎁 Send Points
          </button>
        </div>
      </div>

      {/* Stats */}
      <div className="rewards-stats">
        <div className="stat-card">
          <span className="stat-icon">🎯</span>
          <div className="stat-info">
            <span className="stat-value">{teamMembers.reduce((sum, m) => sum + m.points, 0).toLocaleString()}</span>
            <span className="stat-label">Total Points Outstanding</span>
          </div>
        </div>
        <div className="stat-card">
          <span className="stat-icon">📊</span>
          <div className="stat-info">
            <span className="stat-value">{recentRedemptions.length}</span>
            <span className="stat-label">Redemptions This Month</span>
          </div>
        </div>
        <div className="stat-card">
          <span className="stat-icon">💰</span>
          <div className="stat-info">
            <span className="stat-value">$850</span>
            <span className="stat-label">Rewards Value (Month)</span>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="rewards-tabs">
        <button 
          className={activeTab === 'catalog' ? 'active' : ''}
          onClick={() => setActiveTab('catalog')}
        >
          🎁 Reward Catalog
        </button>
        <button 
          className={activeTab === 'leaderboard' ? 'active' : ''}
          onClick={() => setActiveTab('leaderboard')}
        >
          🏆 Leaderboard
        </button>
        <button 
          className={activeTab === 'redemptions' ? 'active' : ''}
          onClick={() => setActiveTab('redemptions')}
        >
          📋 Redemptions
        </button>
        <button 
          className={activeTab === 'history' ? 'active' : ''}
          onClick={() => setActiveTab('history')}
        >
          📜 Points History
        </button>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === 'catalog' && (
          <div className="catalog-tab">
            {/* Category Filter */}
            <div className="category-filter">
              <button 
                className={selectedCategory === 'all' ? 'active' : ''}
                onClick={() => setSelectedCategory('all')}
              >
                All
              </button>
              <button 
                className={selectedCategory === 'gift_card' ? 'active' : ''}
                onClick={() => setSelectedCategory('gift_card')}
              >
                Gift Cards
              </button>
              <button 
                className={selectedCategory === 'experience' ? 'active' : ''}
                onClick={() => setSelectedCategory('experience')}
              >
                Experiences
              </button>
              <button 
                className={selectedCategory === 'time_off' ? 'active' : ''}
                onClick={() => setSelectedCategory('time_off')}
              >
                Time Off
              </button>
            </div>

            {/* Rewards Grid */}
            <div className="rewards-grid">
              {filteredRewards.map(reward => (
                <div key={reward.id} className="reward-card">
                  <div className="reward-icon">{reward.icon}</div>
                  <h4>{reward.name}</h4>
                  <p>{reward.description}</p>
                  <div className="reward-footer">
                    <span className="points">{reward.points} pts</span>
                    {reward.stock === 'limited' && (
                      <span className="stock">{reward.remaining} left</span>
                    )}
                  </div>
                  <button className="btn small" disabled title="Coming soon">Edit</button>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'leaderboard' && (
          <div className="leaderboard-tab">
            <div className="leaderboard">
              {teamMembers
                .sort((a, b) => b.points - a.points)
                .map((member, index) => (
                  <div key={member.id} className={`leaderboard-item rank-${index + 1}`}>
                    <span className="rank">
                      {index === 0 && '🥇'}
                      {index === 1 && '🥈'}
                      {index === 2 && '🥉'}
                      {index > 2 && `#${index + 1}`}
                    </span>
                    <div className="member-info">
                      <span className="name">{member.name}</span>
                    </div>
                    <span className="points">{member.points} pts</span>
                    <button 
                      className="btn small"
                      onClick={() => {
                        setSelectedReward(member);
                        setShowSendRewardModal(true);
                      }}
                    >
                      + Add
                    </button>
                  </div>
                ))
              }
            </div>
          </div>
        )}

        {activeTab === 'redemptions' && (
          <div className="redemptions-tab">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Team Member</th>
                  <th>Reward</th>
                  <th>Points</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {recentRedemptions.map(redemption => (
                  <tr key={redemption.id}>
                    <td>{redemption.date}</td>
                    <td>{redemption.member}</td>
                    <td>{redemption.reward}</td>
                    <td>{redemption.points}</td>
                    <td>
                      <span className={`status-badge ${redemption.status}`}>
                        {redemption.status}
                      </span>
                    </td>
                    <td>
                      {redemption.status === 'approved' && (
                        <button className="btn small primary" disabled title="Coming soon">Mark Fulfilled</button>
                      )}
                      {redemption.status === 'fulfilled' && (
                        <span className="fulfilled">✓</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {activeTab === 'history' && (
          <div className="history-tab">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Team Member</th>
                  <th>Type</th>
                  <th>Points</th>
                  <th>Reason</th>
                </tr>
              </thead>
              <tbody>
                {pointsHistory.map(item => (
                  <tr key={item.id}>
                    <td>{item.date}</td>
                    <td>{item.member}</td>
                    <td>
                      <span className={`type-badge ${item.type}`}>
                        {item.type}
                      </span>
                    </td>
                    <td className={item.points > 0 ? 'positive' : 'negative'}>
                      {item.points > 0 ? '+' : ''}{item.points}
                    </td>
                    <td>{item.reason}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Send Points Modal */}
      {showSendRewardModal && (
        <SendPointsModal 
          teamMembers={teamMembers}
          preselectedMember={selectedReward}
          onClose={() => {
            setShowSendRewardModal(false);
            setSelectedReward(null);
          }}
        />
      )}
    </div>
  );
};

// Send Points Modal
const SendPointsModal = ({ teamMembers, preselectedMember, onClose }) => {
  const [formData, setFormData] = useState({
    recipient: preselectedMember?.id || '',
    points: '',
    reason: '',
    sendToAll: false
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const quickReasons = [
    { label: 'Completed project on time', points: 50 },
    { label: 'Excellent quality work', points: 75 },
    { label: 'Helped a teammate', points: 25 },
    { label: 'Client compliment', points: 100 },
    { label: 'Monthly bonus', points: 25 },
    { label: 'Rush project completion', points: 100 },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    setSubmitting(true);

    const points = parseInt(formData.points, 10);
    const recipients = formData.sendToAll
      ? teamMembers
      : teamMembers.filter(m => m.id === formData.recipient);

    const results = await Promise.all(
      recipients.map(m =>
        api.post('/api/rewards/award', {
          member_id: m.id,
          points,
          reason: formData.reason
        })
      )
    );

    setSubmitting(false);

    const failed = results.filter(r => !r.success);
    if (failed.length > 0) {
      setSubmitError(failed[0].error || 'Failed to send points. Please try again.');
      return;
    }

    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>🎁 Send Reward Points</h3>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="checkbox-label">
              <input 
                type="checkbox"
                checked={formData.sendToAll}
                onChange={e => setFormData({...formData, sendToAll: e.target.checked})}
              />
              Send to entire team
            </label>
          </div>

          {!formData.sendToAll && (
            <div className="form-group">
              <label>Recipient</label>
              <select 
                value={formData.recipient}
                onChange={e => setFormData({...formData, recipient: e.target.value})}
                required={!formData.sendToAll}
              >
                <option value="">Select team member...</option>
                {teamMembers.map(m => (
                  <option key={m.id} value={m.id}>{m.name} ({m.points} pts)</option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group">
            <label>Points to Award</label>
            <input 
              type="number"
              value={formData.points}
              onChange={e => setFormData({...formData, points: e.target.value})}
              placeholder="e.g., 50"
              min="1"
              required
            />
          </div>

          <div className="form-group">
            <label>Reason</label>
            <textarea 
              value={formData.reason}
              onChange={e => setFormData({...formData, reason: e.target.value})}
              placeholder="What are you rewarding them for?"
              rows={2}
              required
            />
          </div>

          <div className="quick-reasons">
            <label>Quick Select:</label>
            <div className="reason-chips">
              {quickReasons.map((r, i) => (
                <button 
                  key={i}
                  type="button"
                  className="chip"
                  onClick={() => setFormData({
                    ...formData, 
                    reason: r.label,
                    points: r.points.toString()
                  })}
                >
                  {r.label} (+{r.points})
                </button>
              ))}
            </div>
          </div>

          {submitError && (
            <div className="error-banner">{submitError}</div>
          )}

          <div className="modal-actions">
            <button type="button" className="btn secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn primary" disabled={submitting}>
              {submitting ? 'Sending...' : '🎁 Send Points'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RewardsManager;
